import type { InvoiceDetails } from '~/credsystem/domain/invoices';
import type { InvoiceDetailsDTO } from '~/credsystem/dto/invoices';
import { invoiceDetailDtoToInvoiceDetail } from '~/credsystem/mappers/invoice';
import { apiCredSystemInvoices } from '~/credsystem/services/apiCredSystem';

export async function getCredsystemCardInvoiceDetails(
  id: number
): Promise<InvoiceDetails[] | null> {
  try {
    const response = await apiCredSystemInvoices.get<InvoiceDetailsDTO[]>(
      `/extrato/api/v1/detalhe/` + id
    );

    return response.data.map(invoiceDetailDtoToInvoiceDetail);
  } catch (error) {
    return null;
  }
}
